import { render, staticRenderFns } from "./domainDetailModal.vue?vue&type=template&id=4c6b57ef&scoped=true&"
import script from "./domainDetailModal.vue?vue&type=script&lang=js&"
export * from "./domainDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./domainDetailModal.vue?vue&type=style&index=0&id=4c6b57ef&prod&lang=less&scoped=true&"
import style1 from "./domainDetailModal.vue?vue&type=style&index=1&id=4c6b57ef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b57ef",
  null
  
)

export default component.exports